var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home p-5 h-75 w-100 d-flex justify-content-center align-items-center"},[_c('h2',{staticClass:"text-center text-info"},[_vm._v(_vm._s(_vm.$t('pageWelcomeText'))),_c('br'),_vm._v(_vm._s(_vm.$t('pageSiteName')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }